import BackendConnector from './backendConnector';

export default class UserMessageTemplateHttpService {
    static getMessageTemplatesByType(templateType) {
        return BackendConnector.get(`user/message/templates/${templateType}`);
    }

    static addMessageTemplateByType(templateType, template) {
        return BackendConnector.put(`user/message/templates/${templateType}`, template);
    }

    static updateMessageTemplateByType(templateType, template) {
        return BackendConnector.post(`user/message/templates/${templateType}`, template);
    }

    static deleteMessageTemplateByType(templateType, templateName) {
        return BackendConnector.post(`/user/message/templates/${templateType}/delete`, { templateName });
    }

    static getLastTemplateUsage(templateType) {
        return BackendConnector.get(`/user/message/templates/${templateType}/lastUsage`);
    }

    static addLastTemplateUsage(templateType, templateName, templatesUsageHistoryType, campaignId) {
        return BackendConnector.post(`/user/message/templates/${templateType}/lastUsage`, {
            templateName,
            templatesUsageHistoryType,
            ...(campaignId && { campaignId }),
        });
    }
}
